export class AuditService {
    static async log() {
        return null;
    }

    static async logFieldChanges() {
        return null;
    }

    static async getForEntity() {
        return [];
    }

    static async getAll() {
        return [];
    }
}
